import _extends from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["price", "interval"];
import React from "react";
import { Flex, Span } from "@catchoftheday/cg-components";
import { rem } from "@catchoftheday/theme";
import { formatPrice } from "@catchoftheday/utilities";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PlanPriceBox = function PlanPriceBox(_ref) {
  var price = _ref.price,
      interval = _ref.interval,
      props = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(Flex, _extends({
    backgroundColor: "onePass.primaryLighter",
    borderRadius: "corner",
    color: "onePass.primaryDarker",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: "1 0 0",
    minHeight: rem("120px"),
    px: 5
  }, props), ___EmotionJSX(Span, {
    fontWeight: "extrabold",
    fontSize: "6xl",
    lineHeight: 1
  }, formatPrice(price, false)), ___EmotionJSX(Span, {
    fontWeight: "bold",
    fontSize: "sm"
  }, "/ ", interval));
};